var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonPlain',_vm._g(_vm._b({staticClass:"button-mnemonic-word"},'ButtonPlain',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.iconClose)?_c('Close'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }